import React, { FormEvent, useMemo } from "react";
import toast from "react-hot-toast";
import { api, CompanyEmployeeInviteGroupCreateDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Entity, Error, LoadingDots, Modal } from "shared/ui";

export interface IEmployeeInviteCreateModal extends UseModalProps {
  companySlug: string;
  data: CompanyEmployeeInviteGroupCreateDto;
}

export const EmployeeInviteCreateModal = (props: IEmployeeInviteCreateModal) => {
  const submit = useApiMethod(api.companyEmployeeInvite.companyEmployeeInviteCreate);
  const inviteList = api.companyEmployeeInvite.useCompanyEmployeeInviteList(props.companySlug);
  const roles = api.companyRbac.useCompanyEmployeeRoleList(props.companySlug);

  const roleNames = useMemo(() => new Map(roles.data?.map((it) => [it.id, it.name])), [roles.data]);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, props.data);
    await inviteList.mutate();
    await props.onSuccess();
    toast.success("Приглашения отправлены.");
  };

  return (
    <Modal onClose={props.close} width={500}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Приглашение сотрудников</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {props.data.invites.map((it, key) => (
            <Entity key={key}>
              <Entity.Field title={it.email} style={{ flexBasis: "fit-content" }} />
              <Entity.Field
                flex
                description={roleNames.get(it.companyEmployeeRoleId)}
                style={{ flexBasis: "fit-content" }}
                right
              />
            </Entity>
          ))}

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Отмена
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Пригласить" : <LoadingDots size={4}>Приглашаем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

EmployeeInviteCreateModal.defaultProps = {};
